import { Divider } from "@mui/joy";
import React, { useEffect, useState } from "react";
import CustomButton from "../../../Shared/CustomButton";
import CustomDiv from "../../../Shared/CustomDiv";
import Text from "../../../Shared/Text";
import { Link, useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import { API_URLS } from "../../../Config/API_URLS";
import axiosInstance from "../../../Config/axios";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";
import { checkPincodeFn } from "../../../Services/CheckPincode";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../../Redux/Actions/ThemeMode";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import {
  HelpOutline,
  ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { CircularProgress, Rating } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import ReactImageMagnify from "react-image-magnify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  rounded: 2,
};
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ProductPage = () => {
  const { id, variant_id } = useParams();
  const [thumbnail, setThumbnail] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(false);
  const [tab, setTab] = useState("Description");
  const [variantColor, setVariantColor] = useState("");
  const [variantStorage, setVariantStorage] = useState("");
  const [variant, setVariant] = useState("");
  const [pincode, setPincode] = useState([]);
  const [img1, setImg1] = useState("");
  const [delivery, setDelivery] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [images, setImages] = useState(true);
  const [isCart, setIsCart] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open2, setOpen2] = React.useState(false);

  const handleClickOpen2 = (img) => {
    setImg1(img);
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  console.log("");
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
  };

  const navigate = useNavigate();

  const handleThaumbnailClick = (src) => {
    setThumbnail(src);
    setImages(false);
  };

  const productDetailData = () => {
    setIsLoading(true);
    const reqbody = new FormData();
    reqbody.append("product_id", id);
    reqbody.append("variant_id", variant_id);
    axiosInstance
      .post(
        `api/store/new-product-deatils/?variant_color_value_id=${variantColor}&variant_storage_value_id=${variantStorage}&other_variants_value_id=${variant}`,
        reqbody
      )
      .then((response) => {
        setIsLoading(false);
        setDetail(response.data.data[0]?.product_deatils[0]);
        setData(response.data.data[0].related_products);

        client.refetchQueries(["myCartList"]);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };

  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };

  const client = useQueryClient();
  const addToCart = (event, variantId) => {
    event.stopPropagation();
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    setIsCart(true);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
        setIsCart(false);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };

  const topRetedAdd = () => {
    const reqBody = new FormData();
    reqBody.append("product_variant_id", variant_id);
    axiosInstance
      .post(API_URLS.topreatedAdd, reqBody)
      .then((response) => {})
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };

  useEffect(() => {
    productDetailData();
    topRetedAdd();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [variantColor, variantStorage, id]);

  const emptyFunction = () => {};
  const { mutate } = useMutation(checkPincodeFn, {
    onSuccess: (response) => {
      response.data.response_code === 200
        ? setDelivery(
            `Delivery within ${response.data.delivery_time} in ${response.data.city_name}`
          )
        : emptyFunction();
    },
  });
  useEffect(
    () => {
      setThumbnail(
        detail?.product_variant_value_list?.[0]?.varients_multiple_image?.[
          imageIndex
        ]?.variant_image
      );
      imageIndex && setImages(false);
    },
    // eslint-disable-next-line
    [imageIndex]
  );
  useEffect(() => {
    pincode.length === 6 ? mutate({ zipcode: pincode }) : emptyFunction();
  }, [pincode]);
  console.log("indexNo:", imageIndex);
  console.log(
    "index length",
    detail?.product_variant_value_list?.[0]?.varients_multiple_image.length
  );
  useEffect(() => {
    variantStorage && setVariantColor(detail?.variant_color_value?.[0]?.id);
  }, [variantStorage]);

  console.log(data, "shivam");

  return isLoading ? (
    <>
      <CustomDiv className="flex h-[90vh] justify-center items-center">
        <CircularProgress size="lg" color="primary" />
      </CustomDiv>
    </>
  ) : (
    <CustomDiv className="flex flex-col overflow-x-hidden  shadow px-[2%] lg:px-[3%] lg:py-[8%] w-full">
      <CustomDiv className="flex lg:flex-row flex-col w-full  ">
        <CustomDiv className="flex items-center flex-col lg:w-[20%] pl-20 ">
          {detail?.product_variant_value_list?.[0]?.varients_multiple_image
            .length === 0 ? (
            <></>
          ) : (
            <span className="flex flex-col  gap-2  p-2 lg:mt-14 lg:block hidden">
              <div className="flex flex-col items-center gap-2 ">
                {detail?.product_variant_value_list?.[0]
                  ?.varients_multiple_image?.length !== 1 && (
                  <IconButton
                    className=""
                    onClick={() =>
                      imageIndex !== 0 && setImageIndex(imageIndex - 1)
                    }
                  >
                    <ExpandLessIcon className="!text-5xl" />
                  </IconButton>
                )}
                <div className="flex flex-col hide-scroll gap-1 max-h-[500px] overflow-y-auto">
                  {detail?.product_variant_value_list?.[0]?.varients_multiple_image.map(
                    (item, index) => {
                      return (
                        <img
                          alt=""
                          src={item.variant_image}
                          onClick={() => {
                            setThumbnail(item.variant_image);
                            setImages(false);
                          }}
                          className={classNames(
                            "lg:w-16 lg:h-20 h-12 w-12 border-2 lg:cursor-pointer border-gray-200",
                            (item.variant_image === thumbnail ||
                              (!thumbnail && index === 0)) &&
                              "border-2 !border-orange-600"
                          )}
                        />
                      );
                    }
                  )}
                </div>
                {detail?.product_variant_value_list?.[0]
                  ?.varients_multiple_image.length !== 1 && (
                  <IconButton
                    className=""
                    onClick={() =>
                      detail?.product_variant_value_list?.[0]
                        ?.varients_multiple_image.length ===
                      imageIndex + 1
                        ? setImageIndex(0)
                        : imageIndex !==
                            detail?.product_variant_value_list?.[0]
                              ?.varients_multiple_image?.length -
                              1 && setImageIndex(imageIndex + 1)
                    }
                  >
                    <ExpandMoreIcon className="!text-5xl" />
                  </IconButton>
                )}
              </div>
            </span>
          )}
        </CustomDiv>
        <CustomDiv className="flex flex-col lg:pr-10 my-5  lg:w-[40%] ">
          <div className="flex justify-start items-center">
            <div>
              {detail?.product_variant_value_list?.[0]?.varients_multiple_image
                .length === 0 ? (
                <></>
              ) : (
                <>
                  {detail?.product_variant_value_list?.[0]
                    ?.varients_multiple_image?.length !== 1 && (
                    <IconButton
                      className="!border !border-solid lg:!p-1 !p-0.5"
                      onClick={() =>
                        imageIndex !== 0 && setImageIndex(imageIndex - 1)
                      }
                    >
                      <ArrowBackIos className="!pl-1.5" />
                    </IconButton>
                  )}
                </>
              )}
            </div>
            <div>
              {images ? (
                <div className=" flex imag flex-col  ">
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: "Wristwatch by Ted Baker London",
                        isFluidWidth: true,
                        src: detail?.product_variant_value_list?.[0]
                          ?.variant_image,
                        width: 500,
                        height: 500,
                      },
                      largeImage: {
                        src: detail?.product_variant_value_list?.[0]
                          ?.variant_image,
                        width: 1200,
                        height: 1800,
                      },
                      enlargedImageContainerStyle: {
                        zIndex: "1500",
                      },
                    }}
                  />
                </div>
              ) : (
                <div className="flex justify-center imag items-center border bg-gray-100 my-5">
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: "Product Detail",
                        isFluidWidth: true,
                        src: `${thumbnail}`,
                      },
                      largeImage: {
                        src: `${thumbnail}`,
                        width: 1800,
                        height: 1800,
                      },
                      lensStyle: {
                        borderColor: "rgba(255,255,255,.5)",
                      },
                      shouldUsePositiveSpaceLens: true,
                      className: "z-40",
                    }}
                  />
                </div>
              )}
            </div>
            <div>
              {detail?.product_variant_value_list?.[0]?.varients_multiple_image
                .length === 0 ? (
                <></>
              ) : (
                <>
                  {detail?.product_variant_value_list?.[0]
                    ?.varients_multiple_image?.length !== 1 && (
                    <IconButton
                      className="!border !border-solid lg:!p-1 !p-0.5"
                      onClick={() =>
                        detail?.product_variant_value_list?.[0]
                          ?.varients_multiple_image.length ===
                        imageIndex + 1
                          ? setImageIndex(0)
                          : imageIndex !==
                              detail?.product_variant_value_list?.[0]
                                ?.varients_multiple_image?.length -
                                1 && setImageIndex(imageIndex + 1)
                      }
                    >
                      <ArrowForwardIos className="p-1" />
                    </IconButton>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="lg:block hidden  px-5 ">
            <CustomDiv className="flex flex-col  justify-center gap-5 items-center w-full bg-gray-200 p-3 my-5  ">
              <span className="flex justify-center items-center gap-2 ">
                {detail?.is_active_replacement || detail?.is_active_return ? (
                  <Text onClick={handleOpen}>
                    {detail?.is_active_replacement &&
                      detail?.time_period_replacement_policy}
                    <HelpOutline />
                    {detail?.is_active_return &&
                      detail?.time_period_return_replacement_policy}
                  </Text>
                ) : (
                  <Text onClick={handleOpen}>
                    No Return or Replacement Applicable <HelpOutline />
                  </Text>
                )}
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="child-modal-title"
                  aria-describedby="child-modal-description"
                >
                  <Box
                    sx={{ ...style, width: 600 }}
                    className="!border-0 outline-none"
                  >
                    {(detail?.is_active_replacement ||
                      detail?.is_active_return) && (
                      <>
                        <div className="flex justify-between bg-gray-300 p-2">
                          <p>Validity</p>
                          <p>Cover</p>
                          <p>Type Accepted</p>
                        </div>
                        <div className="flex justify-between p-2">
                          <p>{detail?.validity}</p>
                          <p>{detail?.covers}</p>
                          <p>{detail?.type_accepted}</p>
                        </div>
                      </>
                    )}
                    {detail?.is_active_replacement && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: detail?.replacement_policy,
                        }}
                      ></p>
                    )}

                    {detail?.is_active_return && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            detail?.is_active_return &&
                            detail?.return_and_refund_replacement_policy,
                        }}
                      ></p>
                    )}
                    {!(
                      detail?.is_active_replacement || detail?.is_active_return
                    ) && (
                      <>
                        <p>This product is not eligible for returns.</p>
                      </>
                    )}
                  </Box>
                </Modal>
              </span>

              <Text className="lg:block hidden">Sold by : Fusion Vastras</Text>
            </CustomDiv>
          </div>
        </CustomDiv>

        {/* <Divider orientation="vertical" /> */}

        <CustomDiv className="flex flex-col  top lg:w-[35%]">
          <CustomDiv className="flex flex-col lg:p-5 p-2 gap-3 w-full">
            <span className="border shadow rounded-xl py-5 px-3 bg-gray-100">
              <Text className="lg:text-xl text-lg font-semibold">
                {detail?.product_variant_value_list?.[0]?.variant_name}
              </Text>

              <Text>{detail?.sub_category}</Text>

              <span className="flex flex-col  text-lg gap-2">
                {detail?.product_variant_value_list?.[0]?.quantity === "0" ? (
                  <Text className="text-red-500 text-lg font-semibold">
                    Out-OF-stock
                  </Text>
                ) : (
                  <Text className="text-green-500 text-lg font-semibold">
                    In-stock
                  </Text>
                )}

                <Text className="text-sm">Product HSN : {detail?.HSN}</Text>
              </span>
            </span>
            <span className="border shadow rounded-xl py-5 px-3 bg-gray-100">
              {detail?.product_variant_value_list?.[0]?.color_variant_values ===
              "" ? (
                <></>
              ) : (
                <Text className="uppercase font-bold">
                  {detail?.variant_color?.[0]?.title}
                </Text>
              )}

              <CustomDiv className="flex gap-5 overflow-x-auto w-[400px] my-2 hide-scroll">
                {detail?.variant_color_value?.map((color) => {
                  return (
                    <CustomDiv
                      className={classNames(
                        "flex flex-col cursor-pointer border-[2px] transition-all duration-300 p-1 rounded",
                        detail?.product_variant_value_list?.[0]
                          ?.color_variant_values_id === color.id
                          ? "border-gray-800 !rounded-lg "
                          : "border-gray-200 !rounded-lg"
                      )}
                      // onChange={() => setVariantColor(color.id)}
                    >
                      <Text>{color.color}</Text>
                    </CustomDiv>
                  );
                })}
              </CustomDiv>

              <Text className="uppercase !font-bold">
                {detail?.variant_storage?.[0]?.title}
              </Text>
              <CustomDiv className="flex gap-5 overflow-x-auto w-[400px] hide-scroll">
                {detail?.variant_storage_value?.map((storage) => {
                  return (
                    <CustomDiv
                      className={classNames(
                        "flex flex-col cursor-pointer border-[2px] transition-all duration-300 p-1 rounded px-5",
                        detail?.product_variant_value_list?.[0]
                          ?.storage_variant_values_id === storage.id
                          ? "border-gray-800 !rounded-lg"
                          : "border-gray-200 !rounded-lg"
                      )}
                      onClick={() => setVariantStorage(storage.id)}
                    >
                      <Text>{storage.value}</Text>
                    </CustomDiv>
                  );
                })}
              </CustomDiv>

              <Text className="uppercase ">
                {detail?.other_variants?.[0]?.title}
              </Text>

              <CustomDiv className="flex gap-5 overflow-x-auto w-[400px] hide-scroll">
                {detail?.other_variants_value?.map((ram) => {
                  return (
                    <CustomDiv
                      className={classNames(
                        "flex flex-col cursor-pointer border-[3px] transition-all duration-300 p-2 rounded",
                        detail?.product_variant_value_list?.[0]
                          ?.other_variant_values_id === ram.id
                          ? "border-gray-800 rounded-lg"
                          : "border-gray-200 rounded-lg"
                      )}
                      onClick={() => setVariant(ram.id)}
                    >
                      <Text>{ram.value}</Text>
                    </CustomDiv>
                  );
                })}
              </CustomDiv>
            </span>
            <span className="border shadow rounded-xl py-5 px-3 bg-gray-100">
              <span className="flex gap-5 my-3">
                <p className="font-bold">Rating:</p>
                <Rating
                  name="read-only"
                  value={detail?.product_variant_value_list?.[0]?.rating}
                  readOnly
                />
              </span>

              <Text className="text-lg">
                MRP
                <span className="line-through mx-1">
                  ₹{detail?.product_variant_value_list?.[0]?.variant_price}
                </span>
                <span className="text-green-600 mx-1">
                  Save
                  <span className="mx-1">
                    {Number(
                      detail?.product_variant_value_list?.[0].discount_percent
                    )}
                    %
                  </span>
                </span>
                <span className="font-bold text-xl mx-1">
                  ₹{detail?.product_variant_value_list?.[0]?.actual_price}
                </span>
              </Text>

              <Text>Inclusive of all taxes</Text>

              <CustomDiv className="flex flex-col lg:flex-row items-center lg:px-10 justify-around gap-2 my-2 w-full">
                {isCart ? (
                  <CustomButton className="!rounded-md !w-72 lg:!w-full !bg-gray-700 !px-10 !py-2">
                    <CircularProgress size={35} color="inherit" />
                  </CustomButton>
                ) : (
                  <CustomButton
                    className="!rounded-md !w-72 lg:!w-full !bg-gray-700 !px-10 !py-2"
                    onClick={(event) =>
                      localStorage.getItem("token")
                        ? addToCart(
                            event,
                            detail?.product_variant_value_list?.[0]?.variant_id
                          )
                        : handleLogin()
                    }
                  >
                    Add To Cart
                  </CustomButton>
                )}
              </CustomDiv>
            </span>
          </CustomDiv>
          <CustomDiv className="flex flex-col  justify-center gap-5 items-center px-5 w-full bg-gray-200 p-3 my-5 lg:hidden">
            <span className="flex justify-center items-center gap-2">
              <div className="">
                {detail?.is_active_replacement || detail?.is_active_return ? (
                  <Text onClick={handleOpen}>
                    {detail?.is_active_replacement &&
                      detail?.time_period_replacement_policy}
                    <HelpOutline />
                    {detail?.is_active_return &&
                      detail?.time_period_return_replacement_policy}
                  </Text>
                ) : (
                  <Text onClick={handleOpen}>
                    No Return or Replacement Applicable <HelpOutline />
                  </Text>
                )}
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="child-modal-title"
                  aria-describedby="child-modal-description"
                >
                  <Box
                    sx={{ ...style, width: 600 }}
                    className="!border-0 outline-none"
                  >
                    {(detail?.is_active_replacement ||
                      detail?.is_active_return) && (
                      <>
                        <div className="flex justify-between bg-gray-300 p-2">
                          <p>Validity</p>
                          <p>Cover</p>
                          <p>Type Accepted</p>
                        </div>
                        <div className="flex justify-between p-2">
                          <p>{detail?.validity}</p>
                          <p>{detail?.covers}</p>
                          <p>{detail?.type_accepted}</p>
                        </div>
                      </>
                    )}
                    {detail?.is_active_replacement && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: detail?.replacement_policy,
                        }}
                      ></p>
                    )}

                    {detail?.is_active_return && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            detail?.is_active_return &&
                            detail?.return_and_refund_replacement_policy,
                        }}
                      ></p>
                    )}
                    {!(
                      detail?.is_active_replacement || detail?.is_active_return
                    ) && (
                      <>
                        <p>This product is not eligible for returns.</p>
                      </>
                    )}
                  </Box>
                </Modal>
              </div>
            </span>

            <Text>Sold by : Fusion Vastras Pvt. Ltd.</Text>
          </CustomDiv>
          <Text className="text-xl my-5 font-bold pl-5">
            Product Description
          </Text>
          <CustomDiv className=" w-full shadow flex flex-col pl-5 h-52 rounded-lg overflow-y-auto">
            <CustomDiv className="flex gap-3 px-2">
              {["Description"].map((item) => {
                return (
                  <Link onClick={() => setTab(item)} to="#">
                    <Text
                      className={classNames(
                        "border-b-2 border-red-500 border-opacity-0 hover:border-opacity-100 p-2",
                        tab === item ? "!border-opacity-100 !text-red-500" : ""
                      )}
                    >
                      {item}
                    </Text>
                  </Link>
                );
              })}
            </CustomDiv>
            <Divider />
            <CustomDiv>
              {tab === "Description" ? (
                <div
                  dangerouslySetInnerHTML={{ __html: detail?.description }}
                  className="p-5"
                ></div>
              ) : tab === "Ingredients" ? (
                <Text className="p-5">
                  Ingredients : Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Dicta, mollitia! Veritatis repellat maiores
                  blanditiis corporis, non maxime placeat soluta incidunt a
                  suscipit fuga voluptatum ducimus architecto ipsum eveniet
                  error deleniti?
                </Text>
              ) : (
                <Text className="p-5">
                  How To Use : Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Dicta, mollitia! Veritatis repellat maiores
                  blanditiis corporis, non maxime placeat soluta incidunt a
                  suscipit fuga voluptatum ducimus architecto ipsum eveniet
                  error deleniti?
                </Text>
              )}
            </CustomDiv>
          </CustomDiv>
        </CustomDiv>
      </CustomDiv>

      <div className="flex flex-col justify-center items-center">
        <div className="w-full">
          <p className="text-xl font-bold py-2 pl-10 ">Specification</p>
        </div>

        <table className="w-full px-10 bg-white ">
          <thead className="bg-gray-300">
            <tr>
              <th></th>
              {detail?.product_variant_value_list?.[0].product_specification?.[0]?.product_specification_category?.map(
                (val, key) => {
                  return <th className="py-1">{val.specification_type}</th>;
                }
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              {detail?.product_variant_value_list?.[0].product_specification.map(
                (item) => {
                  return (
                    <td className="text-center border-b py-1">
                      {item.category}
                    </td>
                  );
                }
              )}

              {detail?.product_variant_value_list?.[0].product_specification?.[0]?.product_specification_category?.map(
                (val) => {
                  return (
                    <td className="text-center border-b py-1">
                      {val.specification_value}
                    </td>
                  );
                }
              )}
            </tr>
          </tbody>
        </table>
        {/* <div className="lg:w-full w-full overflow-x-auto PX-20 ">
          <div className="flex flex-row justify-between items-center px-44 bg-gray-300 py-2">
            <p>CHEST</p>
            <p>VALUE</p>
          </div>

          {detail?.product_variant_value_list?.[0].product_specification?.[0]?.product_specification_category.map(
            (item) => {
              return (
                <tr className="flex flex-row  justify-between items-center w-full px-44 border-b">
                  <td className="!p-2 lg:text-xm text-sm">
                    {item.specification_type}
                  </td>

                  <td className="!p-2 lg:text-xm text-sm">
                    {item.specification_value}
                  </td>
                </tr>
              );
            }
          )}
        </div> */}
      </div>
      <CustomDiv className="my-5">
        <Text className="text-xl font-semibold">Related Products</Text>
        <CustomDiv className="flex gap-4 my-5 py-1 w-full overflow-x-auto">
          {data?.map((product) => {
            return (
              <CustomDiv
                className="rounded-md h-fit w-[250px] duration-200 shadow bg-white cursor-pointer "
                onClick={() =>
                  navigate(
                    `/product/${product?.product_id}/${product?.variant_id}`
                  )
                }
              >
                <span className="centerdiv">
                  <img
                    src={product.product_image}
                    alt=""
                    className="h-52 relative"
                  />
                </span>
                <CustomDiv className="flex flex-col justify-between p-4 space-y-2">
                  <CustomDiv className="space-y-2">
                    <Text className="text-lg class-name font-semibold">
                      {product.variant_name}
                    </Text>
                  </CustomDiv>
                  <Text className="text-sm uppercase">
                    {product.main_category}
                  </Text>
                  <CustomDiv className="flex items-center gap-1">
                    <Text className="font-bold">₹{product.price}</Text>
                    <Text className="font-bold text-xl"></Text>
                    <Text className="text-green-600">
                      {product.discount_percent !== "0.0"
                        ? `(${product.discount_percent})% OFF`
                        : null}
                    </Text>
                  </CustomDiv>
                  <span className="flex gap-4">
                    {isCart ? (
                      <CustomButton
                        type="button"
                        className="!rounded w-full !bg-gray-700"
                      >
                        <CircularProgress size={35} color="inherit" />
                      </CustomButton>
                    ) : (
                      <button
                        onClick={(event) =>
                          localStorage.getItem("token")
                            ? addToCart(event, product.variant_id)
                            : handleLogin()
                        }
                        className=" lg:text-base text-sm  flex gap-5 "
                      >
                        <ShoppingCartOutlinedIcon /> <p>Add To Bag</p>
                      </button>
                    )}
                  </span>
                </CustomDiv>
              </CustomDiv>
            );
          })}
        </CustomDiv>
      </CustomDiv>
    </CustomDiv>

    //     <>
    //     <div className='p-5 text-sm'>
    // <p className=''> Home | Bags | Cross Bags | <span className='font-bold'>Padlock Envelope Crossbody Bag</span></p>
    // </div>

    //    <div className='grid grid-cols-2'>
    //     <div className='w-full h-auto flex flex-wrap gap-3 p-2'>
    //         {
    //                 [
    //                     {
    //                         img:"https://www.charleskeith.in/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-in-products/default/dw9406e1d7/images/hi-res/2022-L3-CK2-41220007-01-1.jpg?sw=1152&sh=1536",

    //                     },
    //                     {
    //                         img:"https://www.charleskeith.in/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-in-products/default/dw9406e1d7/images/hi-res/2022-L3-CK2-41220007-01-1.jpg?sw=1152&sh=1536",
    //                     },
    //                     {
    //                         img:"https://www.charleskeith.in/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-in-products/default/dw9406e1d7/images/hi-res/2022-L3-CK2-41220007-01-1.jpg?sw=1152&sh=1536",
    //                     },
    //                     {
    //                         img:"https://www.charleskeith.in/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-in-products/default/dw9406e1d7/images/hi-res/2022-L3-CK2-41220007-01-1.jpg?sw=1152&sh=1536",
    //                     },
    //                     {
    //                         img:"https://www.charleskeith.in/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-in-products/default/dw9406e1d7/images/hi-res/2022-L3-CK2-41220007-01-1.jpg?sw=1152&sh=1536",
    //                     },
    //                 ].map((singleData,index)=>{
    //                     return <div className='w-[49%] py-2'>
    //                         <img className='img' alt="" src={singleData.img}/>
    //                     </div>
    //                 })
    //         }
    //     </div>

    //  <div className=' p-10'>
    //        <div>
    //         <h1 className='text-md font-bold '>Padlock Envelope Crossbody Bag - Chocolate</h1>
    //         <p className='text-[60%] text-gray-500'>Item No. CK2-80770605_CHOCO_S</p>
    //         <p className='font-bold'>₹7,499</p>
    //         <p className='mt-10'> Color: <span className='hover:underline font-bold text-red-800'>Chocolate</span></p>
    //         </div>

    // <div className='space-x-5'>
    //     <button className='bg-gray-200 border-black hover:border-2 rounded-full w-5
    //     h-5'></button>
    //         <button className='bg-red-900 border-black hover:border-2 rounded-full w-5
    //     h-5'></button>
    //             <button className='bg-black border-black hover:border-2 rounded-full w-5
    //     h-5'></button>

    // </div>

    // <div>
    // <p>Size : <span className='text-sm text-gray-500'>sm</span></p>
    // <button className='bg-gray-100 border-black hover:border-2 rounded p-2 w-20 h-10'>S</button>
    // </div>

    // <div className='m-auto'>
    // <button className='bg-[#333333] border-black hover:border-2 text-white rounded w-[100%]  h-10 mt-10'>Add to Card</button>
    // </div>

    // <div className=' text-center'>

    //     <div>
    //         <button>
    //         {/* <GoShare/> */}
    //         </button>
    //     </div>
    //     <div className=' '>
    //     <button className='text-black hover:border-2 text-sm'>
    //       Share</button>
    //     </div>

    // </div>

    // <div>

    // </div>

    //     </div>

    //    </div>
    //     </>
  );
};

export default ProductPage;
